module.exports = __webpack_public_path__ + "img/upgrade_student.1b7d2b25.png";